import { WithBodyMessage } from '@weblite/ts-action/message'

export type RecorderStatus =
  | 'IDLE'
  | 'STARTING'
  | 'WAITING'
  | 'RECORD'
  | 'PREVIEW'

export type SendFieldAction =
  | { type: 'NEW_MESSAGE' }
  | { type: 'REPLY'; iid: number }
  | { type: 'EDIT'; message: WithBodyMessage }
  | {
      type: 'FORWARD'
      forward: { roomId: string; iids: number[]; publicHall?: boolean }
    }

export type ImagePreviewTypes = 'comment' | 'tune' | 'crop'
export type VideoPreviewTypes = 'comment' | 'compress' | 'trim'

export const MEDIA_PREVIEW_BUTTON_BAR_HEIGHT = 64
